import type { AutocompleteProps as MuiAutocompleteProps } from '@mui/material';
import {
  autocompleteListBoxStyles,
  AutocompletePaper,
  StyledAutocomplete,
} from 'components/ui/form/Autocomplete/index.js';
import type {
  FormSelectOption,
  GenericFormField,
} from 'components/ui/form/GenericForm/index.js';
import { Input } from 'components/ui/form/Input/index.js';
import {
  isEmpty,
  isEqual,
} from 'es-toolkit/compat';
import type {
  ElementType,
  HTMLAttributes,
  JSX,
  SyntheticEvent,
} from 'react';

export interface AutocompleteProps {
  field: GenericFormField<{
    multiple?: boolean;
    freeSolo?: boolean;
  }>;
  value: string;
  onChange: (event: SyntheticEvent<Element, Event>, value: any) => void;
}

export const Autocomplete = ({ field, onChange, value }: AutocompleteProps) => {
  const formValue = (() => {
    const multiple = field.componentProps?.multiple;
    const emptyValue = multiple ? [] : '';
    const isEmptyValue
      = typeof value === 'undefined'
        || isEmpty(value)
        || (multiple && typeof value[0] === 'undefined')
        || (multiple && value.length < 1)
        || (!multiple && value === emptyValue);

    return isEmptyValue ? emptyValue : value;
  })();

  return (
    <StyledAutocomplete
      {...field?.componentProps ?? {}}
      options={field?.options ?? []}
      clearIcon={null}
      value={formValue}
      onChange={onChange}
      slots={{ paper: AutocompletePaper }}
      slotProps={{
        listbox: { sx: autocompleteListBoxStyles } as HTMLAttributes<HTMLUListElement>,
      }}
      renderInput={(props) => {
        return (
          <Input
            {...props}
            slotProps={{
              htmlInput: {
                ...field.inputProps,
                ...props.inputProps,
                maxLength: 99,
              },
            }}
            data-testid={`input-${field?.name}`}
            placeholder={field?.placeholder ?? ''}
            variant="outlined"
            margin="none"
            fullWidth
          />
        );
      }}
    />
  );
};
